export default __webpack_public_path__ + "static/media/v.c771a94b.mp4";